import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerNavigationServices } from '../services/core_services';

/**
 * RegistryInitializer
 * This component sits inside the Router context to capture 'navigate'
 * and register core services that depend on React Router.
 */
const RegistryInitializer = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Register navigation actions
        registerNavigationServices(navigate);

    }, [navigate]);

    return null; // Render nothing
};

export default RegistryInitializer;
